// ==============================|| SIGNATURES API ||============================== //
// Core "podpis" building block (docs/ARCHITECTURE.md "Signatures - new
// core-level component") - session-gated inside SignatureController itself,
// PIN-verified server-side before anything is stored. No listing function
// here on purpose - see SignatureController's own docblock; a future
// module reads its own signatures back through its OWN admin endpoint.

import { notifySessionExpired } from 'utils/sessionExpired';

async function fetchCsrfToken() {
  const res = await fetch('/auth/csrf-token', { credentials: 'include' });
  const body = await res.json();
  return body?.data?.csrf_token;
}

async function apiGet(path) {
  const res = await fetch(path, { credentials: 'include' });
  const body = await res.json().catch(() => ({}));
  if (!res.ok || body.success === false) {
    if (res.status === 401) notifySessionExpired();
    throw new Error(body.message || 'Požadavek se nezdařil.');
  }
  return body.data;
}

async function apiPost(path, payload) {
  const csrfToken = await fetchCsrfToken();
  const res = await fetch(path, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken },
    body: JSON.stringify(payload)
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok || body.success === false) {
    if (res.status === 401) notifySessionExpired();
    const error = new Error(body.message || 'Požadavek se nezdařil.');
    error.code = body.code;
    throw error;
  }
  return body.data;
}

// contextId may be null (a context_type can mean "this whole kind of
// action", not always one specific row - see migration 036's docblock).
// evidencePhoto may be omitted - only required for flows that ask for one.
export const captureSignature = (contextType, contextId, pin, signatureImage, evidencePhoto) =>
  apiPost('/signatures/capture', {
    context_type: contextType,
    context_id: contextId,
    pin,
    signature_image: signatureImage,
    evidence_photo: evidencePhoto || undefined
  });

// "Test podpisu" (Nastavení uživatele) - e-mailem pošle zpět podpis, který
// caller sám právě zachytil (ownership se ověřuje na serveru).
export const emailTestSignature = (signatureId) => apiPost('/signatures/email-test', { signature_id: signatureId });

// Druhý, nezávislý kanál potvrzení (odkaz v e-mailu) - veřejné, netřeba
// aktivní session, viz SignatureController::confirmEmail()'s docblock.
export const confirmSignatureEmail = (token) => apiPost('/signatures/confirm-email', { token });

// "Test podpisu" ikona ve stavu (Nastavení uživatele) - test se počítá za
// úspěšný, teprve až je potvrzený klikem z e-mailu, ne jen odeslaný.
export const getSignatureTestStatus = () => apiGet('/signatures/test-status');
